import { useEffect, useState } from 'react'
import { useStore } from '../../store'
import { PRODUCTS_ACTIONS } from '../../store/products'
import { authedAxios } from '../../utils'

const EXAMPLE_PRODUCTS = [
  {
    name: 'Cable Setup',
    price: 59.99,
    billingCycleTypeId: 1,
  },
  {
    name: 'Internet + TV Subscription',
    price: 149.99,
    billingCycleTypeId: 2,
  },
  {
    name: 'Sports Package Subscription',
    price: 49.99,
    billingCycleTypeId: 2,
  },
]

const useProducts = (
  // TECH-DEBT: this can use useCompanyConfig
  companyConfig,
  waitForConfig = false,
  includeArchived = false
) => {
  const {
    state: { products, productsExp, billingCycleTypes, billingCycleTypesExp },
    dispatch,
  } = useStore()

  const [localCopy, setLocalCopy] = useState([])

  const [isLoading, setIsLoading] = useState(true)
  const [hasLoadError, setHasLoadError] = useState(false)

  const dirty = localCopy !== EXAMPLE_PRODUCTS

  const isValid = localCopy.every((p) => {
    const string = p.price.toString()
    const isDecimal = string.includes('.')

    return !isDecimal || string.split('.')[1].length === 2
  })

  const commitToStore = (data) =>
    dispatch({
      type: PRODUCTS_ACTIONS.SET_PRODUCTS,
      products: data || localCopy,
    })

  const getProducts = () => {
    if (products?.length > 0 && Date.now() < productsExp) {
      setLocalCopy(products)
      return Promise.resolve()
    }

    if (waitForConfig && !companyConfig.hasSavedProducts) {
      commitToStore(EXAMPLE_PRODUCTS)
      setLocalCopy(EXAMPLE_PRODUCTS)
      return Promise.resolve()
    }

    return authedAxios
      .get(`/api/product?include_archived=${includeArchived}`)
      .then((res) => {
        commitToStore(res.data.products)
        setLocalCopy(res.data.products)
      })
  }

  const getCycleTypes = () => {
    if (billingCycleTypes && Date.now() < billingCycleTypesExp) {
      return Promise.resolve()
    }

    return authedAxios.get('/api/product/cycle-types').then((res) => {
      dispatch({
        type: PRODUCTS_ACTIONS.SET_BILLING_CYCLE_TYPES,
        billingCycleTypes: res.data.billingCycleTypes,
      })
    })
  }

  const saveProducts = () => {
    return authedAxios.put('/api/product', localCopy).then((res) => {
      setLocalCopy(res.data.products)
      commitToStore(res.data.products)
      return res
    })
  }

  useEffect(() => {
    if (waitForConfig && !companyConfig) return

    Promise.all([getProducts(), getCycleTypes()])
      .catch(() => {
        setHasLoadError(true)
      })
      .finally(() => setIsLoading(false))
  }, [companyConfig])

  return {
    products: localCopy,
    billingCycleTypes,
    setProducts: setLocalCopy,
    saveProducts,
    isLoading,
    hasLoadError,
    dirty,
    isValid,
  }
}

export default useProducts
